import { ChatsProvider } from '../../../constants/types';

export const backgroundPatterns = {
  [ChatsProvider.whatsapp]:
    'https://static.elfsight.com/apps/all-in-one-chat/patterns/background-whatsapp.jpg',
  [ChatsProvider.line]:
    'https://static.elfsight.com/apps/all-in-one-chat/patterns/background-line.jpg',
  [ChatsProvider.telegram]:
    'https://static.elfsight.com/apps/all-in-one-chat/patterns/background-telegram.jpg',
  [ChatsProvider.instagram]: '',
  [ChatsProvider.viber]: '',
  [ChatsProvider.discord]: '',
  [ChatsProvider.facebook]: '',
  [ChatsProvider.all]: ''
};
